import {CommandBase} from "./commandBase";
import {BuildingReward, RemoteConstantsModel} from "../models/remoteConstants.model";
import {v4 as uuidv4} from "uuid";

// Appends a default BuildingReward to a building's passiveRewards. Default
// shape: OnPlace trigger granting 0 Gold — minimum-viable card that the user
// fills in via the editor UI.
export class AddBuildingPassiveRewardCommand extends CommandBase {
    buildingId: string;

    constructor(buildingId: string) {
        super();
        this.buildingId = buildingId;
    }

    execute(data: RemoteConstantsModel): boolean {
        const building = data.buildings.find(b => b.id === this.buildingId);
        if (!building) return false;

        const reward: BuildingReward = {
            uid: uuidv4(),
            active: true,
            trigger: {kind: 'OnPlace'},
            grant: {kind: 'Gold', amount: 0},
            amountIncreasePerTrigger: 0,
        };

        building.passiveRewards = [...(building.passiveRewards ?? []), reward];
        return true;
    }
}
